module.exports = __webpack_public_path__ + "media/images/consumer/errors/logged-in-error-page-xs-18af20a4e7a30fc8df6e80610d477c4a.jpg";